/* EV Cable Hub - reg finder: one obvious way to the cable.
 *
 * Diagnosed 22 Sep 2026 on the live homepage with CK23 GMO:
 *   1. "Show me the cable" re-submitted the lookup when a plate was entered,
 *      so pressing it again just re-drew the same result. It never navigated.
 *   2. The only route to the product was one link in a row of four identical
 *      buttons. It overflowed the card (cut off on mobile), and three of the
 *      four rendered as bare text because nothing styled .reg-result-actions.
 *   3. The spec rows had no styling at all ("Charge portType 2"), and the
 *      charge-time line listed rapid rates as "0m" and a 22kW time on an 11kW
 *      car.
 *   4. The iOS keyboard stayed up after the lookup, so the first tap on the
 *      result only dismissed it and shifted the layout: the "double tap".
 *
 * This file fixes those without touching the worker contract, the V2L rules in
 * reg-lookup.js, or the product/length resolvers. It works on whatever those
 * scripts leave in the result region, and waits for them to finish before
 * sending anyone anywhere.
 */
(function () {
  'use strict';
  if (window.__evchRegUx) return;
  window.__evchRegUx = true;

  var GO_LABEL = 'Go to my cable';
  var MAX_WAIT = 7000;      /* worker + product resolver + length resolver */
  var PRODUCT_GRACE = 2600; /* how long a collection-only result may still be upgraded to a product */
  var LENGTH_GRACE = 1500;  /* how long to wait for the length resolver */

  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }

  function isResult(region) {
    return !region.hidden && (region.classList.contains('reg-result-match') ||
      region.classList.contains('reg-result-fallback'));
  }

  function renderedReg(region) {
    var s = region.querySelector('.reg-result-car small');
    var m = s && /Registration\s+([A-Z0-9 ]+)/i.exec(s.textContent);
    return m ? norm(m[1]) : '';
  }

  function primaryLink(region) {
    var acts = region.querySelector('.reg-result-actions');
    if (!acts) return null;
    return acts.querySelector('a.btn-dark') || acts.querySelector('a[href*="/products/"]') ||
      acts.querySelector('a[href]');
  }

  function isShoppable(a) {
    var h = a && a.getAttribute('href') || '';
    return /\/(products|collections)\//.test(h);
  }

  /* Rapid rates are DC and come back as 0m; anything above the car's own AC
     ceiling just repeats the ceiling. Neither helps anyone choose a cable. */
  function tidySpec(region) {
    var rows = region.querySelectorAll('.reg-spec-row');
    var max = null, timeRow = null;
    Array.prototype.forEach.call(rows, function (r) {
      var k = (r.querySelector('span') || {}).textContent || '';
      if (/max ac/i.test(k)) max = parseFloat((r.querySelector('strong') || {}).textContent);
      if (/charge time/i.test(k)) timeRow = r;
    });
    if (!timeRow || timeRow.getAttribute('data-tidy')) return;
    var val = timeRow.querySelector('strong');
    if (!val) return;
    var keep = val.textContent.split(/\s*·\s*/).filter(function (part) {
      var m = /^([\d.]+)kW:\s*(.*)$/.exec(part.trim());
      if (!m) return false;
      if (/^0m$/.test(m[2].trim())) return false;
      return !(max && parseFloat(m[1]) > max);
    });
    timeRow.setAttribute('data-tidy', '1');
    if (!keep.length) { timeRow.parentNode.removeChild(timeRow); return; }
    val.textContent = keep.join(' · ');
    var label = timeRow.querySelector('span');
    if (label) label.textContent = 'Charge time 10-80%';
  }

  function submitButton(form) { return form.querySelector('.reg-lookup-submit'); }

  function setSubmitLabel(form, text) {
    var b = submitButton(form);
    if (!b || !b.firstChild || b.firstChild.nodeType !== 3) return;
    if (!b.hasAttribute('data-default-label')) b.setAttribute('data-default-label', b.firstChild.nodeValue);
    b.firstChild.nodeValue = text + ' ';
    b.classList.toggle('is-go', text === GO_LABEL);
  }

  function restoreSubmitLabel(form) {
    var b = submitButton(form);
    if (!b || !b.classList.contains('is-go')) return;
    b.firstChild.nodeValue = b.getAttribute('data-default-label') || 'Find my cable ';
    b.classList.remove('is-go');
  }

  function decorate(region) {
    var form = region.closest('[data-reg-lookup]');
    if (!isResult(region)) {
      region.classList.remove('has-primary');
      return null;
    }
    tidySpec(region);
    var a = primaryLink(region);
    Array.prototype.forEach.call(region.querySelectorAll('.reg-result-actions a'), function (x) {
      x.classList.toggle('reg-result-primary', x === a);
    });
    region.classList.toggle('has-primary', !!a);
    var car = region.querySelector('.reg-result-car');
    if (car) car.classList.toggle('is-link', isShoppable(a));
    if (form) {
      var input = form.querySelector('.plate-input');
      if (isShoppable(a) && input && norm(input.value) === renderedReg(region)) setSubmitLabel(form, GO_LABEL);
      else restoreSubmitLabel(form);
    }
    return a;
  }

  /* A result is ready to follow once the product resolver has had its chance
     to upgrade a collection link, and the length resolver has applied the
     distance answer. */
  function ready(region, since) {
    var a = primaryLink(region);
    if (!isShoppable(a)) return false;
    var waited = Date.now() - since;
    var h = a.getAttribute('href');
    if (/\/collections\//.test(h) && waited < PRODUCT_GRACE) return false;
    var distanceChosen = !!document.querySelector('.opt-distance.is-selected');
    if (/\/products\//.test(h) && distanceChosen && !a.hasAttribute('data-length-applied') &&
        waited < LENGTH_GRACE) return false;
    return true;
  }

  function follow(region) {
    var a = primaryLink(region);
    if (!isShoppable(a)) return false;
    window.location.href = a.href;
    return true;
  }

  /* Public: the three-question card's button calls this. With a result for
     the same plate already on screen it goes straight there; otherwise it runs
     the lookup and goes as soon as the answer has settled. Non-EVs, errors and
     "we don't stock that" answers stay on screen, because there is nowhere
     useful to send them. */
  function go(form) {
    var region = form.querySelector('[data-reg-result]');
    var input = form.querySelector('.plate-input');
    if (!region || !input) return false;
    if (isResult(region) && norm(input.value) === renderedReg(region) && follow(region)) return true;

    var started = Date.now(), resultAt = 0;
    form.setAttribute('data-go-on-result', '1');
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    (function tick() {
      if (form.getAttribute('data-go-on-result') !== '1') return;
      if (region.classList.contains('reg-result-notev') || Date.now() - started > MAX_WAIT) {
        form.removeAttribute('data-go-on-result');
        return;
      }
      if (isResult(region)) {
        if (!resultAt) resultAt = Date.now();
        if (ready(region, resultAt)) {
          form.removeAttribute('data-go-on-result');
          if (follow(region)) return;
        }
      }
      setTimeout(tick, 120);
    })();
    return true;
  }
  window.evchRegGo = go;

  /* Pressing the plate's own button again on the same plate goes to the
     cable instead of drawing the same result a second time. Capture phase on
     the document so it runs before reg-lookup.js's submit handler. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-reg-lookup]')) return;
    if (form.getAttribute('data-go-on-result') === '1') return;
    var region = form.querySelector('[data-reg-result]');
    var input = form.querySelector('.plate-input');
    if (!region || !input || !isResult(region)) return;
    if (norm(input.value) !== renderedReg(region)) return;
    if (!isShoppable(primaryLink(region))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    follow(region);
  }, true);

  /* The car name is the biggest thing in the result, and people tap it. */
  document.addEventListener('click', function (e) {
    var car = e.target && e.target.closest ? e.target.closest('.reg-result-car.is-link') : null;
    if (!car) return;
    var region = car.closest('[data-reg-result]');
    if (region) follow(region);
  });

  /* Editing the plate means the old result no longer answers the button. */
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('plate-input')) return;
    var form = input.closest('[data-reg-lookup]');
    var region = form && form.querySelector('[data-reg-result]');
    if (form && region) decorate(region);
  });

  function watch() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-reg-result]'), function (region) {
      if (region.__evchUx) return;
      region.__evchUx = true;
      var wasResult = false;
      var pending = false;
      function run() {
        pending = false;
        var now = isResult(region);
        decorate(region);
        /* First paint of a result: drop the keyboard so the next tap lands
           where the finger is, not on whatever the layout shifted under it. */
        if (now && !wasResult) {
          var form = region.closest('[data-reg-lookup]');
          var input = form && form.querySelector('.plate-input');
          if (input && document.activeElement === input) input.blur();
        }
        wasResult = now;
      }
      if (!window.MutationObserver) return;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        (window.requestAnimationFrame || setTimeout)(run);
      }).observe(region, { childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['href', 'class', 'hidden'] });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();
